import { gql } from '@apollo/client'
import { AUDIT_INVENTORY_ITEM_FRAGMENT } from './AuditInventoryItemFragment'

export const WHOLE_DISPLAY_AUDIT_FRAGMENT = gql`
  fragment WholeDisplayAudit on DisplayAudit {
    __typename
    id
    predictions
    products {
      ...AuditInventoryItem
    }
    dateCompleted
    display {
      id
      area
      displayType
      shortDescription
      isCompetitor
    }
    employee {
      id
      email
    }
  }
  ${AUDIT_INVENTORY_ITEM_FRAGMENT}
`
